import React from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../utility/imageHelper";
import { useStore } from "../context/StoreContext"; // ✅ Use StoreContext
import "./styles/ShopCategories.css";

const ShopCategories = () => {
  const { categories } = useStore(); // ✅ Get categories from StoreContext

  

  return (
    <div className="section-content">
      <div className="categories-grid">
        {categories.map((category) => (
          <Link
            key={category.id}
            to={`/shop-knives/category/${category.name.toLowerCase().replace(/\s+/g, "-")}`}
            className="category-card"
            style={{
              backgroundImage: category.image_url ? `url(${getImageUrl(category.image_url)})` : "none",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            aria-label={`Browse ${category.name} knives`}
          >
            <h3 className="category-name">{category.name}</h3>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ShopCategories;
